import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Profil',
    [language_item]: 'Skift sprog',
    [support_item]: 'Support',
    [logout_item]: 'Log ud',
  },
};
